import { render } from "./ViewLoader.vue?vue&type=template&id=1ea84714&scoped=true"
import script from "./ViewLoader.vue?vue&type=script&lang=js"
export * from "./ViewLoader.vue?vue&type=script&lang=js"

import "./ViewLoader.vue?vue&type=style&index=0&id=1ea84714&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea84714"]])

export default __exports__